"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var polished_1 = require("polished");
var styled_components_1 = require("styled-components");
var colors_1 = require("./colors");
var styles_1 = require("./styles");
exports.darkenBackground = function (background, theme) {
    var result = background;
    if (background) {
        result = polished_1.darken(0.0629, colors_1.normalizeColor(background, theme)); // Seems this is the amount of darken
    }
    return result;
};
exports.normalizeBackground = function (background, theme) {
    // If the background has a light or dark object, use that
    var result = background;
    if (background) {
        var themeIsDark = !!(theme && theme.dark);
        if (themeIsDark && background.dark && typeof background.dark !== 'boolean') {
            result = background.dark;
        }
        else if (!themeIsDark && background.light && typeof background.light !== 'boolean') {
            result = background.light;
        }
        result = styles_1.evalStyle(result, theme);
    }
    return result;
};
exports.backgroundIsDark = function (backgroundArg, theme) {
    var background = exports.normalizeBackground(backgroundArg, theme);
    var result;
    if (background) {
        if (typeof background === 'object') {
            var color = background.color, dark = background.dark, opacity = background.opacity;
            if (typeof dark === 'boolean') {
                result = dark;
            }
            else if (color &&
                // weak opacity means we keep the existing darkness
                (!opacity || opacity !== 'weak')) {
                var backgroundColor = colors_1.normalizeColor(background.color, theme);
                if (backgroundColor) {
                    result = colors_1.colorIsDark(backgroundColor);
                }
            }
        }
        else {
            var color = colors_1.normalizeColor(background, theme);
            if (color) {
                result = colors_1.colorIsDark(color);
            }
        }
    }
    return result;
};
exports.backgroundStyle = function (backgroundArg, theme, textColorArg) {
    // If the background has a light or dark object, use that
    var background = exports.normalizeBackground(backgroundArg, theme);
    var textColor = textColorArg || theme.global.colors.text;
    if (typeof background === 'object') {
        var styles = [];
        if (background.image) {
            var color = void 0;
            if (background.dark === false) {
                color = textColor.light;
            }
            else if (background.dark) {
                color = textColor.dark;
            }
            else if (!textColorArg) {
                color = 'inherit';
            }
            styles.push(styled_components_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n        background-image: ", ";\n        background-repeat: no-repeat;\n        background-position: ", ";\n        background-size: cover;\n        color: ", ";\n      "], ["\n        background-image: ", ";\n        background-repeat: no-repeat;\n        background-position: ", ";\n        background-size: cover;\n        color: ", ";\n      "])), background.image, background.position || 'center center', color));
        }
        if (background.color) {
            var color = colors_1.normalizeColor(background.color, theme);
            var backgroundColor = colors_1.getRGBA(color, background.opacity === true
                ? theme.global.opacity.medium
                : theme.global.opacity[background.opacity]) || color;
            styles.push(styled_components_1.css(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n        background-color: ", ";\n        ", "\n      "], ["\n        background-color: ", ";\n        ",
                "\n      "])), backgroundColor, (!background.opacity || background.opacity !== 'weak') &&
                "color: " + textColor[background.dark || colors_1.colorIsDark(backgroundColor) ? 'dark' : 'light'] + ";"));
        }
        if (background.dark === false) {
            styles.push(styled_components_1.css(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n        color: ", ";\n      "], ["\n        color: ", ";\n      "])), textColor.light));
        }
        else if (background.dark) {
            styles.push(styled_components_1.css(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n        color: ", ";\n      "], ["\n        color: ", ";\n      "])), textColor.dark));
        }
        return styles;
    }
    if (background) {
        if (background.lastIndexOf('url', 0) === 0) {
            return styled_components_1.css(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n        background: ", " no-repeat center center;\n        background-size: cover;\n      "], ["\n        background: ", " no-repeat center center;\n        background-size: cover;\n      "])), background);
        }
        var color = colors_1.normalizeColor(background, theme);
        if (color) {
            return styled_components_1.css(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n        background: ", ";\n        color: ", ";\n      "], ["\n        background: ", ";\n        color: ", ";\n      "])), color, textColor[colors_1.colorIsDark(color) ? 'dark' : 'light']);
        }
    }
    return undefined;
};
exports.activeStyle = styled_components_1.css(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n  ", "\n  color: ", ";\n"], ["\n  ", "\n  color: ", ";\n"])), function (props) { return exports.backgroundStyle(colors_1.normalizeColor(props.theme.global.hover.background, props.theme), props.theme); }, function (props) { return colors_1.normalizeColor(props.theme.global.hover.color, props.theme); });
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=background.js.map